<template>
  <div class="feed-row" :style="{ opacity: rowOpacity }">
    <span class="dot" :style="{ background: dotColor, boxShadow: `0 0 6px ${dotColor}99` }" />
    <span class="message">{{ message }}</span>
    <span class="timestamp">{{ timestamp }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  type:      { type: String, default: "info" },   // info | success | warning | error
  message:   { type: String, required: true },
  createdAt: { type: String, default: null },
  index:     { type: Number, default: 0 },
})

const dotColor = computed(() => {
  const map = {
    success: "#4ade80",
    info:    "#60a5fa",
    warning: "#fbbf24",
    error:   "#f87171",
    amber:   "#f5a623",
  }
  return map[props.type] ?? "#60a5fa"
})

const rowOpacity = computed(() => Math.max(1 - props.index * 0.08, 0.3))

const timestamp = computed(() => {
  if (!props.createdAt) return ""
  const d = new Date(props.createdAt)
  return d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })
})
</script>

<style scoped>
.feed-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 4px;
}

.message {
  font-family: var(--font-mono);
  font-size: 11px;
  color: #e8e6e3;
  line-height: 1.5;
  flex: 1;
}

.timestamp {
  font-family: var(--font-mono);
  font-size: 9px;
  color: rgba(232, 230, 227, 0.25);
  flex-shrink: 0;
  margin-top: 2px;
}
</style>
